// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./index.d.ts" />

import { SoftrPageRenderer } from "./SoftrPageRenderer";

export default SoftrPageRenderer;
